var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex wrap"},_vm._l((_vm.files),function(file,idx){return _c('input-img-uploader',{key:'file-'+_vm.fileKeys[idx],attrs:{"useLabel":false,"value":file,"files":_vm.files,"index":idx},on:{"update:value":_vm.addImg,"delImg":_vm.delImg}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }